export default "__VITE_ASSET__CMQHj_xZ__"